// import { createStore, applyMiddleware, compose } from 'redux';
// // import createSagaMiddleware from "redux-saga";
// import reducers from './reducers';
// // import sagas from "./sagas";

// // const sagaMiddleware = createSagaMiddleware();
// const middlewares = [sagaMiddleware];

// export function configureStore(initialState) {
//     const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

//     const store = createStore(
//         reducers,
//         initialState,
//         composeEnhancers(
//             applyMiddleware(...middlewares)
//         ),
//     );
//     // sagaMiddleware.run(sagas);
//     return store;
// }

import thunk from 'redux-thunk';
import logger from 'redux-logger';
import { createStore, applyMiddleware, compose } from 'redux';
import reducers from './reducers';

// eslint-disable-next-line import/no-mutable-exports
let store;

export const configureStore = initialState => {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  const appliedMiddleware = isDev ? applyMiddleware(thunk, logger) : applyMiddleware(thunk);

  store = initialState
    ? createStore(
      reducers,
      initialState,
      composeEnhancers(appliedMiddleware),
    )
    : createStore(reducers, composeEnhancers(appliedMiddleware));

  return store;
};
export default store;
const getStore = () => store;
export const getState = () => getStore()?.getState();
export const dispatch = data => getStore()?.dispatch(data);
